import { render, staticRenderFns } from "./DefaultAccount.vue?vue&type=template&id=20d5560e&scoped=true"
import script from "./DefaultAccount.vue?vue&type=script&lang=ts"
export * from "./DefaultAccount.vue?vue&type=script&lang=ts"
import style0 from "./DefaultAccount.vue?vue&type=style&index=0&id=20d5560e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5560e",
  null
  
)

export default component.exports